import React, { useState } from "react";
import { Contact } from "../Contact/Contact";
import styles from "./Sidebar.module.scss";
import { GAevent } from "../../utils/googleAnalyticsHelper";

// const classNames = require("classnames");

const SidebarComponent = () => {
  const [toggle, setToggle] = useState(true);

  const showSidebar = () => {
    setToggle(!toggle);
    GAevent("Guest-User", "click", "Menu Button");
  };

  return (
    <div className={styles.sidebar}>
      <div className={`${styles.toggleContainer} sidebar`} onClick={showSidebar}>
        <span className="sidebar">Menu</span>
        <img
          src={process.env.PUBLIC_URL + "/images/toggle.svg"}
          className={toggle ? styles.showMenu : styles.hideMenu}
          alt="Toggle Icon"
          srcSet=""
        />
      </div>
      <div className={toggle ? styles.openSidebar : styles.closeSidebar}>
        {toggle ? (
          <div className={styles.btnContainerShow}>
            <Contact />
          </div>
        ) : (
          <div className={styles.btnContainerHide}>
            <Contact />
          </div>
        )}
      </div>
    </div>
  );
};

const Sidebar = React.memo(SidebarComponent);

export { Sidebar };
